const ZONA = 'America/Costa_Rica';

/** "21/10/2026 14:35", en hora de Costa Rica, a partir de un instante (ISO). */
export function formatearFechaHoraCR(iso: string): string {
  return new Date(iso).toLocaleString('es-CR', {
    timeZone: ZONA,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** Hoy en Costa Rica, AAAA-MM-DD. */
export function hoyCR(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: ZONA });
}

/** El día (AAAA-MM-DD) de calendario de Costa Rica de un instante ISO; una fecha sin hora se deja igual. */
function diaCR(texto: string): string {
  return /^\d{4}-\d{2}-\d{2}$/.test(texto)
    ? texto
    : new Date(texto).toLocaleDateString('en-CA', { timeZone: ZONA });
}

/** Días de calendario entre dos fechas o instantes (hasta = hoy si no se da). Nunca negativo. */
export function diasEntre(desde: string, hasta?: string): number {
  const [a, b] = [diaCR(desde), hasta ? diaCR(hasta) : hoyCR()].map((d) => {
    const [y, m, dd] = d.split('-').map(Number) as [number, number, number];
    return Date.UTC(y, m - 1, dd);
  }) as [number, number];
  return Math.max(0, Math.round((b - a) / 86_400_000));
}

/** El día (AAAA-MM-DD) en Costa Rica de una fecha o instante. */
export const diaDeCR = diaCR;

/** Lunes (AAAA-MM-DD) de la semana de una fecha o instante, sumando `semanas` semanas. */
export function lunesDeSemana(texto: string = hoyCR(), semanas = 0): string {
  const [y, m, d] = diaCR(texto).split('-').map(Number) as [number, number, number];
  const fecha = new Date(Date.UTC(y, m - 1, d));
  fecha.setUTCDate(fecha.getUTCDate() - ((fecha.getUTCDay() + 6) % 7) + semanas * 7);
  return fecha.toISOString().slice(0, 10);
}

/** "hoy", "ayer" o "hace 7 días". */
export function textoHace(dias: number): string {
  if (dias === 0) return 'hoy';
  if (dias === 1) return 'ayer';
  return `hace ${dias} días`;
}
